export const debounce = (debouncedFunction: (...params: unknown[]) => void, debounceTime = 500) => {
  let timeout: null | ReturnType<typeof setTimeout> = null;
  return (...params: unknown[]) => {
    if (timeout) {
      clearTimeout(timeout);
    }
    timeout = setTimeout(() => debouncedFunction(params), debounceTime);
  };
};
